import { apiClient } from '@/api/apiClient'
import { GoodsCode } from '@/common'
import { useQuery } from '@tanstack/react-query'

const buildQueryString = (params: Record<string, string | null | undefined | string[]>) => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) {return}

    if (Array.isArray(value)) {
      // For arrays, add multiple parameters with the same name
      value.forEach(item => {
        searchParams.append(key, item)
      })
    } else {
      // For single values, add normally
      searchParams.append(key, value)
    }
  })

  return searchParams.toString()
}

export const useGoodsCodes = ({
  productionMethod,
  aggregatedGoodsCategories
}: {
  productionMethod?: string | null
  aggregatedGoodsCategories?: string[]
}) => {
  return useQuery<GoodsCode[]>({
    queryKey: ['goodsCodes', productionMethod, aggregatedGoodsCategories],
    queryFn: async () => {
      const queryString = buildQueryString({
        productionMethod,
        aggregatedGoodsCategories
      })
      const url = queryString ? `/v1/config/goods?${queryString}` : '/v1/config/goods'

      const response = await apiClient.get(url)
      return response.data
    },
  })
}
